<template>
  <div v-if="contract_manager">
    <h1 class="main-header">
      <translate translate-context="contract_managers"
                 :translate-params="{id: contract_manager.id, name: contract_manager.name}">
        Roles - Contract Manager #%{id} - %{name}
      </translate>
    </h1>

    <CCard>
      <CCardHeader>
        <h4 v-translate translate-context="contract_manager">Roles</h4>
        <div class="card-header-actions">
          <CButton color="primary" @click="onCreateNewRole" v-translate
                   v-if="hasPerm('contract_manager.role.create')">Create Role
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody class="p-0">
        <Roles @edit="onEditRole"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {RecordNotFound} from "@/domain/core/exception/exceptions";
import Roles from "@/domain/contract_manager/components/Roles.vue";

export default {
  name: 'RolesPage',
  components: {
    Roles
  },
  data() {
    return {
      loading: true,
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchConfig({type: 'contract_manager_detail', id: this.$route.params.id}),
        this.fetchContractManager(this.$route.params.id)
      ])
      // I ruoli vengono caricati dal componente Roles
    } catch (e) {
      if (e instanceof RecordNotFound) {
        await this.$router.push({name: 'contract_manager.list'})
      }
    }
    this.loading = false
  },
  computed: {
    ...mapGetters('contractManager', [
      'contract_manager',
    ]),
  },
  methods: {
    ...mapActions('contractManager', [
      'fetchContractManager',
    ]),
    ...mapActions('login', [
      'fetchConfig'
    ]),
    onCreateNewRole() {
      this.$router.push({
        name: 'contract_manager.role.create', 
        params: {id: this.contract_manager.id}
      })
    },
    onEditRole(role) {
      this.$router.push({
        name: 'contract_manager.role.edit', 
        params: {
          id: this.contract_manager.id, 
          role_id: role.id
        }
      })
    },
  }
}
</script>